import JsonView from './JsonView';

export default JsonView;